
namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    export class ReportRefundReasonByBillGrid extends Serenity.EntityGrid<ReportRefundReasonByBillRow, any> {
        protected getColumnsKey() { return ReportRefundReasonByBillColumns.columnsKey; }
        protected getDialogType() { return ReportRefundReasonByBillDialog; }
        protected getIdProperty() { return ReportRefundReasonByBillRow.idProperty; }
        protected getInsertPermission() { return ReportRefundReasonByBillRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportRefundReasonByBillRow.localTextPrefix; }
        protected getService() { return ReportRefundReasonByBillService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'refresh-button'), 1)
            //  buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
             buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
             //buttons.push(send);


             // Add buttons import excel, pdf
             buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                 grid: this,
                 service: ReportRefundReasonByBillService.baseUrl + '/ListExcel',
                 onViewSubmit: () => this.onViewSubmit(),
                 separator: true
             }));

             buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRyReportRefundReasonSumBill/edit/128';
                        return false;
                    },
                }
            );


            return buttons;
        }
    }
}